export { default } from './FullWide';
